import React from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import Menu from './Menu'
import '../css/elements/left-sidebar-1.css'
import '../css/elements/collapsed-left-sidebar-1.css'

const LeftSidebar1 = ({ navigation, config }) => {
  if (config.layout === 'top-navigation-1' || config.layout === 'empty-view-1' || config.layout === 'empty-view-2') {
    return (
      <div />
    )
  }
  return (
    <div>
      <div className='left-sidebar-placeholder' />
      <div className='left-sidebar left-sidebar-1'>
        <div className='wrapper'>
          <div className='content'>
            {navigation.map(({ title, items }, i) =>
              <div key={i} className='section'>
                <div className='section-title'>{title}</div>
                <ul className='list-unstyled'>
                  {items.map((items, i) => <Menu key={i} items={items} />)}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ navigation, config }, ownProps) => ({ navigation, config })
export default connect(mapStateToProps)(LeftSidebar1)



// WEBPACK FOOTER //
// ./src/elements/LeftSidebar1.js